import { schema } from "normalizr";
import omit from "lodash.omit";

/**
 * Transform a bet returned by Pricing API into our internal format
 *
 * @ignore
 * @param original
 */
const transformBet = original =>
  omit(original, ["documentId", "optionsAvailable"]);

/**
 * Transform a leg returned by Pricing API into our internal format
 *
 * @ignore
 * @param original
 */
const transformLeg = original =>
  omit(original, ["optionsAvailable", "documentId"]);

/**
 * Transform an outcome returned by Pricing API into our internal format
 *
 * @ignore
 * @param original
 */
const transformOutcome = original => {
  const newOutcome = omit(original, [
    "eachWay",
    "marketRef",
    "eventRef",
    "typeRef",
    "classRef",
    "categoryRef",
    "minAccumulator",
    "maxAccumulator"
  ]);
  newOutcome.marketId = original.marketRef;
  newOutcome.eventId = original.eventRef;
  return newOutcome;
};
/**
 * Transform a related outcome returned by Pricing API into our internal format
 *
 * @ignore
 * @param original
 */
const transformRelatedOutcome = original => omit(original, ["id"]);

/** Transforms the entity keys at the top level to the response structure expected
 * by the betslip reducers. Used after the data has been normalised
 *
 * @ignore
 * @param original response
 */
export const transformKeys = original => {
  var newEntities = omit(original.entities, ["legs", "bets"]);
  newEntities.legs = original.entities.legs;
  newEntities.bets = original.entities.bets;
  return newEntities;
};
/**
 * Defines the shape of the legOutome response from the PricingAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const legOutcome = new schema.Entity(
  "outcomes",
  {},
  {
    idAttribute: "outcomeRef"
  }
);
/**
 * Defines the shape of the outome response from the PricingAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const outcome = new schema.Entity(
  "outcomes",
  {},
  {
    processStrategy: entity => transformOutcome(entity)
  }
);
/**
 * Defines the shape of the related outcomes response from the PricingAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const related = new schema.Entity(
  "relatedOutcomes",
  {},
  {
    processStrategy: entity => transformRelatedOutcome(entity)
  }
);

/**
 * Defines the shape of the leg response from the PricingAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const leg = new schema.Entity(
  "legs",
  { outcomes: [legOutcome] },
  {
    idAttribute: "documentId",
    processStrategy: entity => transformLeg(entity)
  }
);

/**
 * Defines the shape of the bet response from the PricingAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {schema.Entity}
 */
const bet = new schema.Entity(
  "bets",
  {},
  {
    idAttribute: "documentId",
    processStrategy: entity => transformBet(entity)
  }
);

/**
 * Defines the shape of the PricingAPI.
 * Used to flatten the Data Model returned.
 *
 * @ignore
 * @type {{
 *  outcomes: schema.Entity[],
 *  legs: schema.Entity[],
 *  bets: schema.Entity[],
 *  relatedOutcomes: schema.Entity[]
 *  }}
 */
export const pricingApiSchema = {
  outcomes: [outcome],
  relatedOutcomes: [related],
  legs: [leg],
  bets: [bet]
};



// WEBPACK FOOTER //
// ./src/apis/pricing/pricingApiSchema.js